import apiShare from '../../apis/apiShare.mjs'
import parseMap from '../../scripts/parseMap.mjs'

export default id => {
    return async () => {
        const mapData = await apiShare.read({id})
        return parseMap(mapData)
    }
}
